import { useCallback } from "react";
import { ProductSearchRequest } from "reedy-data/api";
import { useApi } from "~/hooks/use-api";
import { BULK_BOOKS_LIMIT } from "~/shared/constants";
import { mapElasticsearchResponse } from "./adapters";
import { SearchResultHit } from "./types";

// Imperative fetch (not React Query) to avoid cache pollution from one-off bulk exports.
export const useSearchAll = () => {
  const api = useApi();

  const searchAll = useCallback(
    async (
      searchRequestParams: ProductSearchRequest,
    ): Promise<SearchResultHit[]> => {
      const response = await api.products.searchProducts({
        ...searchRequestParams,
        page: 1,
        per_page: BULK_BOOKS_LIMIT,
      });
      return mapElasticsearchResponse(response ?? undefined).hits;
    },
    [api],
  );

  return { searchAll };
};
